module.exports = __webpack_public_path__ + "img/34_13.32be5811.png";